import { ContextualMenuItemType } from "office-ui-fabric-react/lib/ContextualMenu";
var onListClick = function (e, item) {
    item.dashboard.listLayout();
};
var onTabsClick = function (e, item) {
    item.dashboard.stackLayout();
};
var onTwoColumnSplitClick = function (e, item) {
    item.dashboard.twoColumnSplitLayout();
};
var onThreeColumnSplitClick = function (e, item) {
    item.dashboard.threeColumnSplitLayout();
};
var createDashboardLayoutItems = function (dashboard) {
    return [
        {
            dashboard: dashboard,
            key: "list",
            name: "Basic",
            iconProps: { iconName: "CollapseMenu" },
            onClick: onListClick,
            checked: dashboard.isListLayout,
            canCheck: true
        },
        {
            dashboard: dashboard,
            key: "stack",
            name: "Tabs",
            iconProps: { iconName: "Redeploy" },
            onClick: onTabsClick,
            checked: dashboard.isStackLayout,
            canCheck: true
        },
        {
            dashboard: dashboard,
            key: "twoColumnSplit",
            name: "Two Columns",
            iconProps: { iconName: "DoubleColumn" },
            onClick: onTwoColumnSplitClick,
            checked: dashboard.isTwoColumnSplitLayout,
            canCheck: true
        },
        {
            dashboard: dashboard,
            key: "threeColumnSplit",
            name: "Three Columns",
            iconProps: { iconName: "TripleColumn" },
            onClick: onThreeColumnSplitClick,
            checked: dashboard.isThreeColumnSplitLayout,
            canCheck: true
        },
        {
            dashboard: dashboard,
            key: "other",
            name: "Custom",
            iconProps: { iconName: "ViewDashboard" },
            checked: dashboard.isOtherLayout,
            canCheck: true,
            disabled: true
        }
    ];
};
var createDashboardLayoutSectionItem = function (dashboard) {
    var layoutItems = createDashboardLayoutItems(dashboard);
    return {
        key: "layoutSectionItem",
        itemType: ContextualMenuItemType.Section,
        sectionProps: {
            key: "layoutSection",
            title: "Layout",
            items: layoutItems
        }
    };
};
var createDashboardLayoutItem = function (dashboard) {
    var layoutSectionItem = createDashboardLayoutSectionItem(dashboard);
    var current = layoutSectionItem.sectionProps.items.find(function (item) { return item.checked; });
    return {
        key: "dashboardLayout",
        name: dashboard.sync.syncing ? "Loading..." : dashboard.sync.error ? "Error" : current ? current.name : "Layout",
        iconProps: current ? current.iconProps : { iconName: "ViewDashboard" },
        subMenuProps: {
            items: [layoutSectionItem]
        }
    };
};
var createDashboardSettingsItem = function (dashboard, name) {
    var layoutSectionItem = createDashboardLayoutSectionItem(dashboard);
    return {
        key: "dashboardSettings",
        name: name,
        iconProps: { iconName: "Settings" },
        subMenuProps: {
            items: [layoutSectionItem]
        }
    };
};
var createDashboardListLayoutItem = function (dashboardList) {
    var sync = dashboardList.sync;
    var active = dashboardList.active;
    return !sync.syncing && active ? createDashboardLayoutItem(active) : undefined;
};
export { createDashboardLayoutItems, createDashboardLayoutSectionItem, createDashboardSettingsItem, createDashboardLayoutItem, createDashboardListLayoutItem };
